// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const defaultConfig = {
  apiKey: "AIzaSyAufI7dZRqij-hDTmapvEvEq61gVIfhe1s",
  authDomain: "fleet-sales-system.firebaseapp.com",
  projectId: "fleet-sales-system",
  storageBucket: "fleet-sales-system.appspot.com",
  messagingSenderId: "1059779836166",
  appId: "1:1059779836166:web:25ee533ba51ae8c15c8687",
  measurementId: "G-HHJYYN33DB"
};

const firebaseEnv = (process.env.REACT_APP_ENV || "prod").toLowerCase();

const environmentConfig = {
  dev: {
    firestoreDb: "fleet-sales-system-dev"
  },
  prod: {
    firestoreDb: undefined
  }
};

const resolvedConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || defaultConfig.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || defaultConfig.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || defaultConfig.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || defaultConfig.storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || defaultConfig.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || defaultConfig.appId,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || defaultConfig.measurementId
};

const app = initializeApp(resolvedConfig);

const envSettings = environmentConfig[firebaseEnv] || environmentConfig.prod;
const firestoreDb =
  (process.env.REACT_APP_FIRESTORE_DB && process.env.REACT_APP_FIRESTORE_DB.trim()) ||
  envSettings.firestoreDb;
const db = firestoreDb ? getFirestore(app, firestoreDb) : getFirestore(app);

const functionsRegion = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION;
const functions = functionsRegion ? getFunctions(app, functionsRegion) : getFunctions(app);

const auth = getAuth(app);

export { app, auth, db, functions, firebaseEnv };
